<template>
<div>
<header>
    <a href="#" @click.prevent="goBack" class="back"></a>
    <h1>Turnier umbenennen</h1>
</header>

<section>
    <custom-form :fields="[ { name: 'name', type: 'text', title: 'Name' } ]"
                 v-model="tournament"
                 submitLabel="Speichern"
                 :url="`tournament/${$route.params.id}/rename`"
                 @submitted="onRenamed" />
</section>
</div>
</template>

<script>
import _ from 'underscore'
import base from 'base.vue'
import customForm from 'components/custom-form.vue'

export default {
    mixins: [ base ],
    components: { customForm },
    data () {
        return {
            tournament: { }
        }
    },
    methods: {
        fetchData () {
            const that = this

            return this.$api.get('tournament/' + this.$route.params.id)
            .then(response => {
                that.tournament = response.data
            })
        },
        onRenamed () {
            this.$router.push(`/tournament/${this.$route.params.id}`)
        }
    }
}
</script>



// WEBPACK FOOTER //
// tournament-rename.vue?0fb70871